export default __webpack_public_path__ + "media/metronic/_theme/media/bg/300-4111734a8170f8665394052381fa9dd0.jpg";